export const UPDATE_USER = "UPDATE_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_DATE = "SET_DATE";
export const CACHE_All_USERS = "CACHE_All_USERS";
export const CLEAR_USERS_CACHE = "CLEAR_USERS_CACHE";
export const CACHE_STATS = "CACHE_STATS";
